import { render, staticRenderFns } from "./ArrayFacet.vue?vue&type=template&id=71cc4ca0&"
import script from "./ArrayFacet.vue?vue&type=script&lang=js&"
export * from "./ArrayFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports